import React, { useState } from 'react';
import { Printer, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { printAuthPdf, printPdfBlob } from '@/lib/printPdf';

// Icône « Imprimer » à placer à côté d'un bouton PDF. Masquée sur mobile (hidden md:inline-flex).
// Fournir soit `url` (string ou fonction, fetch authentifié), soit `getBlob` (async → données PDF).
export const PrintButton = ({ url, getBlob, errMsg = "Erreur lors de l'impression", disabled, className = '', testId = 'print-pdf-btn', size = 'sm', variant = 'outline', iconClass = 'w-4 h-4' }) => {
    const [loading, setLoading] = useState(false);
    const handle = async (e) => {
        e.stopPropagation();
        setLoading(true);
        try {
            if (getBlob) {
                const data = await getBlob();
                if (data) await printPdfBlob(data);
            } else {
                await printAuthPdf(typeof url === 'function' ? url() : url, errMsg);
            }
        } catch (err) {
            let detail = errMsg;
            try { detail = JSON.parse(await err.response.data.text()).detail || errMsg; } catch { detail = err.response?.data?.detail || errMsg; }
            toast.error(detail);
        } finally {
            setLoading(false);
        }
    };
    return (
        <Button type="button" size={size} variant={variant} onClick={handle} disabled={disabled || loading}
            title="Imprimer" className={`hidden md:inline-flex ${className}`} data-testid={testId}>
            {loading ? <Loader2 className={`${iconClass} animate-spin`} /> : <Printer className={iconClass} />}
        </Button>
    );
};

export default PrintButton;
